import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SyncService {
  private baseUrl: string = environment.apiUrl + '/sync';

  constructor(private http: HttpClient) {}

  public syncTagsWithIndameta(): Observable<void> {
    return this.http.post<void>(this.baseUrl + '/indameta', null);
  }

  public checkUserSession(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/user-session');
  }
}
